import { nodeKeyWithoutId } from "../node/index.js";
import {} from "./Mod.js";
import {} from "./RuleEntry.js";
import { hasNodeDefinition } from "./hasNodeDefinition.js";
export function findNodeRuleEntries(mod, node) {
    const nodeKey = nodeKeyWithoutId(node);
    const entries = [];
    for (const [key, entry] of mod.ruleEntries) {
        const [firstKey, secondKey] = key.split(" ");
        if ((firstKey === nodeKey || secondKey === nodeKey) &&
            hasNodeDefinition(mod, entry.second) &&
            hasNodeDefinition(mod, entry.first)) {
            if (!entries.find(({ name }) => name === entry.name)) {
                entries.push(entry);
            }
        }
    }
    return entries;
}
//# sourceMappingURL=findNodeRuleEntries.js.map